<script setup lang="ts">
import { type Ref } from "vue";
import type { Option } from "~/core/models/filters";

const { t } = useI18n();
const model: Ref<string[]> = defineModel<string[]>({ required: true });
const props = defineProps<{
  filterDeviceTypeOptions: Option[];
}>();
const computedfilterDeviceTypeOptions = computed(() => {
  return props.filterDeviceTypeOptions.map((option) => {
    return {
      label: option.label,
      value: Array.isArray(option.value)
        ? option.value.join(",")
        : option.value,
    };
  });
});

const deviceTypes = computed({
  get() {
    return props.filterDeviceTypeOptions
      .filter((option) => {
        const values = Array.isArray(option.value)
          ? option.value
          : [option.value];
        return values.some((v) => model.value.includes(v));
      })
      .map((option) =>
        Array.isArray(option.value) ? option.value.join(",") : option.value,
      );
  },
  set(selected: string[]) {
    model.value = selected.flatMap((option) => option.split(","));
  },
});
</script>

<template>
  <div class="bg-white p-6">
    <filter-selectable-list
      v-model="deviceTypes"
      :data="computedfilterDeviceTypeOptions"
      :empty-text="t('dtwins.filters.connectivity.empty')"
      :header="t('device.model')"
      prop="label"
      item-prop="value"
    />
  </div>
</template>
